import React, { useContext, useState } from "react";
import { BSCard, postFetch, prefixProtocol } from "../utils";
import { FormNonFieldErrors } from "./utils";
import { InputField } from "../formItems";
import { AuthContext } from "../context";

function PasswordResetDone() {
  return (
    <>
      <p>
        An email with further instructions has been sent to your email address.
        Follow the instructions and link in that email.
      </p>
      <p>
        If you have not recieved an email please check your junk email to ensure
        that it has not been filtered out.
      </p>
    </>
  );
}

const submitPasswordReset = (e, host, setStatus, setErrors) => {
  e.preventDefault();
  const formData = new FormData(e.target);
  const data = Object.fromEntries(formData.entries());
  console.log("submitPasswordReset", host, data);
  postFetch({
    url: `${prefixProtocol(host)}/auth-rest/password/reset/`,
    data,
    onSuccess: (data) => setStatus("pending"),
    onFailure: (data) => setErrors(Object.values(data)),
  });
};

function PasswordResetForm({ setStatus }) {
  const { host } = useContext(AuthContext);
  const [errors, setErrors] = useState([]);

  return (
    <>
      <p>
        Forgotten your password? Enter your e-mail address below, and we'll
        e-mail instructions for setting a new one.
      </p>
      <form
        className="form"
        onSubmit={(e) => submitPasswordReset(e, host, setStatus, setErrors)}
      >
        {errors.length > 0 && (
          <div className="alert alert-danger form-control-sm">
            <ul style={{ marginLeft: "-1em" }}>
              {errors.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        )}
        <InputField
          attribute="email"
          placeholder="Enter email"
          fieldType="email"
        />

        <div className="form-group">
          <button className="btn btn-sm btn-primary btn-block" type="submit">
            Request a password reset
          </button>
        </div>
      </form>
    </>
  );
}

export default function PasswordResetPage(props) {
  const [status, setStatus] = useState("");

  let title = "Enter your email address";
  let body = <PasswordResetForm setStatus={setStatus} />;

  // If we have submitted the form then show a confirmation
  if (status === "pending") {
    title = "Check your email";
    body = <PasswordResetDone />;
  }

  return (
    <div className="container">
      <div className="col-sm-8 offset-sm-2 mt-3">
        <BSCard title={title} body={body} />
      </div>
    </div>
  );
}
